  <mat-card color="primary"  fxLayoutAlign="start center right" fxlayout="row wrap" style="background-color: #1565c0 !important;
  color: white !important;" class="p-2" >
    <div fxFlex="100" fxFlex.gt-md="50" fxFlex.md="100">
        <div class="logo">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 229 54" preserveAspectRatio="xMidYMid meet"><style type="text/css"> .st0{font-family:'Roboto-Bold';} .st1{font-size:18.2975px;}
            </style><g><text transform="matrix(1 0 0 1 49.7654 47.0313)" class="st0 st1 st2">SILOKA</text><g><text transform="matrix(1 0 0 1 49.7654 47.0313)" class="st0 st1 st2">GALSEN</text></g></g><path d="M156.03,9.45C141.13,2.83,135.5,3.3,122.15,3.3c-19.77,0-24.99,5.32-32.2,9.34c-7.21,4.02-0.12,2.72-22.81,5.32
              c-9.49,1.09-14.94,2.24-18.15,4.33c-3.28,2.13-4.49,6.91-2.82,10.45c0.12,0.25,0.48,0.16,0.48-0.11
              c-0.09-3.61,2.25-12.06,26.16-12.06c20.4,0,8.39-1.29,26.37-10.18c18.67-9.23,41.66-2.79,48.15-0.48
              c6.78,2.41,17.46,6.31,9.17,12.37c-5.83,4.26-24.72,7.1-35.43,8.41c-0.47,0.06-0.42,0.75,0.06,0.74
              c14.47-0.49,45.59-3.06,58.86-15.89C182.05,13.51,170.92,16.07,156.03,9.45z" class="st0"></path><path d="M178.65,19.79c-0.18,0.03-0.37,0.1-0.55,0.22c-1.59,1.04-3.16,2.1-4.8,3.08c-0.85,0.51-1.71,1.01-2.52,1.57
              c-0.4,0.27-0.8,0.58-1.18,0.89c-0.2,0.16-0.41,0.33-0.61,0.5c-0.15,0.13-0.8,0.64-0.33,0.78c0.06,0.02,0.13,0.02,0.2,0.02
              c1.01-0.01,2.02-0.02,3.03-0.02c0.48,0,0.96,0,1.45,0c0.49,0,0.98,0,1.48,0c0.46,0,0.92,0,1.38,0c0.39,0,0.78,0,1.18,0
              c0.28,0,0.56,0,0.85,0c0.13,0,0.27,0,0.42,0c0.88,0,1.59-0.66,1.59-1.49c0,0,0-4.12,0-4.12C180.23,20.32,179.47,19.65,178.65,19.79z
              " class="st0"></path><path d="M98.89,15.32h-4.82c-0.84,0-1.65,0.3-2.28,0.84l-3.27,2.78c-0.47,0.4-0.19,1.16,0.43,1.16h2.89
              c3,0,5.81-1.5,7.47-4C99.53,15.77,99.29,15.32,98.89,15.32z" class="st0"></path><g><text transform="matrix(1 0 0 1 129.4509 47.0313)" class="st0 st1 st2">auto</text></g></svg>
          </div>    
    </div>
    <div fxFlex="100" fxFlex.gt-md="50" fxFlex.md="100" style="text-align:center">
       <h3>Envoyé un Mail</h3>
    </div>   
    <div fxFlex="100" fxFlex.gt-md="50" fxFlex.md="100">
        <mat-icon   style="float: right;" aria-hidden="true">send</mat-icon>
    </div>
  </mat-card>
  <form [formGroup]="Form">
    <div fxLayout="row wrap" fxLayoutAlign="center">
      <div fxFlex="100" fxFlex.gt-md="50" class="p-2" style="margin-top:20px">
        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" (change)="selected($event.value)" [value]="whereMail">
            <mat-radio-button class="example-radio-button"[value]="'all'" style="margin:20px">{{" A Tous"}}</mat-radio-button>
            <mat-radio-button class="example-radio-button"[value]="'unique'" style="margin:20px">{{"Uniquement à :"}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div fxFlex="100" fxFlex.gt-md="100" fxFlex.md="100" class="p-2" style="margin-top:20px" *ngIf="whereMail=='unique'">

          <mat-form-field class="example-chip-list" appearance="outline" >
              <mat-label> <mat-icon>person</mat-icon>Utilisateur</mat-label>
              <mat-chip-list #chipListUser aria-label="Selection d'utilisateur" >
                <mat-chip *ngFor="let user of usersEmail" (removed)="removeUser(user)">{{user}}
                  <button matChipRemove> <mat-icon>cancel</mat-icon> </button>
                </mat-chip>
                <input
                  placeholder="Nouveau utilisateur..."
                  #userInput
                  [formControl]="userCtrl"
                  [matAutocomplete]="auto"
                  [matChipInputFor]="chipListUser"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="addUser($event)"
                  required>
              </mat-chip-list>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedUser($event)" >
                <mat-option *ngFor="let user of filteredUser | async" [value]="user.email">
                  {{user.user_name +' '+user.user_surname}}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="chipListUser.errorState">Champs obligatoire !!</mat-error>
          </mat-form-field>
      </div>

      <div fxFlex="100" fxFlex.gt-md="100" fxFlex.md="100" class="p-2">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label><mat-icon>star</mat-icon><span>Objet</span></mat-label>
              <input matInput formControlName="object">
              <mat-error *ngIf="Form.controls.object.errors?.required">Champs obligatoire !!</mat-error>
          </mat-form-field>
      </div>

      <div fxFlex="100" fxFlex.gt-md="100" fxFlex.md="100" class="p-2">
          <mat-form-field appearance="outline" class="w-100">
              <mat-label><mat-icon>mail</mat-icon> <span>Message</span></mat-label>
              <textarea matInput placeholder="Votre Message..."rows="10" formControlName="message">
              </textarea>
              <mat-error *ngIf="Form.controls.message.errors?.required">Champs obligatoire !!</mat-error>
          </mat-form-field>
      </div>

    </div>
    <div fxLayout="row wrap" fxLayoutAlign="center center">
      <button fxFlex="100" fxFlex.gt-md="30" fxFlex.md="100" mat-flat-button color="warn" style="margin:5px" (click)="close()"><mat-icon>closed</mat-icon> Fermer</button>
      <button fxFlex="100" fxFlex.gt-md="30" fxFlex.md="100" mat-flat-button color="primary" style="margin:5px" (click)="sendMailUser()" [disabled]="Form.invalid">Envoyer <mat-icon>send</mat-icon></button>
    </div>
  </form>
  